/**
 * GENERATED FILE. Do not edit.
 *
 * Written by `nx run landing-blog:content` from content/blog/. Edit the
 * markdown, not this.
 */
import { PostMeta } from '../content/post.model';

/** Published posts, every locale, newest first. Drafts are not here. */
export const POSTS: PostMeta[] = [
  {
    "title": "Budget category percentages: how to split your money",
    "slug": "budget-categories-percentages",
    "description": "How to split your money by percentage, with the 50/30/20 rule, zero-based budgeting and custom splits. Worked examples included.",
    "date": "2026-10-01",
    "lang": "en",
    "tags": [
      "budget categories percentages",
      "50/30/20 rule",
      "zero-based budgeting",
      "personal finance",
      "budget planner"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/budget-categories-percentages/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "How to track your expenses: a simple manual system",
    "slug": "how-to-track-your-expenses",
    "description": "Track your expenses by hand with daily entry, a few clear categories, a mid-month check-in and a review at the end of each period.",
    "date": "2026-09-22",
    "lang": "en",
    "tags": [
      "how to track your expenses",
      "manual expense tracking",
      "personal budgeting tips",
      "offline budget app",
      "expense categories"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/how-to-track-your-expenses/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "Offline budget apps: 10 options for private money tracking",
    "slug": "offline-budget-app",
    "description": "Ten offline budget apps compared on privacy, manual entry, backups, platforms and budgeting depth, for tracking money without a bank link.",
    "date": "2026-09-21",
    "lang": "en",
    "tags": [
      "offline budget app",
      "privacy budgeting apps",
      "manual budget apps",
      "offline expense trackers",
      "personal finance apps"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/offline-budget-app/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "Free budget apps: 10 picks and their honest limits",
    "slug": "free-budget-app",
    "description": "Ten free budget apps compared for privacy, couples, manual entry and investing, with the limits each free plan puts on you.",
    "date": "2026-09-19",
    "lang": "en",
    "tags": [
      "free budget app",
      "budgeting apps",
      "personal finance apps",
      "privacy budgeting",
      "free money tools"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/free-budget-app/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "Best budget apps for Android in 2026: 10 compared",
    "slug": "budget-app-android",
    "description": "Ten budget apps for Android compared on price, privacy, offline use and bank connections, so you can pick one you will keep using.",
    "date": "2026-09-18",
    "lang": "en",
    "tags": [
      "budget app android",
      "Android budgeting apps",
      "personal finance apps",
      "offline budget apps",
      "privacy budgeting"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/budget-app-android/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "Personal budget apps: 10 options compared for 2026",
    "slug": "personal-budget-app",
    "description": "Ten personal budget apps compared on automation, privacy, price and effort, with picks for beginners and for people who never link a bank.",
    "date": "2026-09-17",
    "lang": "en",
    "tags": [
      "personal budget app",
      "budgeting apps",
      "privacy-first budgeting",
      "manual budgeting",
      "expense tracking"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/personal-budget-app/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "Paycheck budget apps: 10 picks for budgeting by payday",
    "slug": "paycheck-budget-app",
    "description": "Ten apps for paycheck budgeting compared, plus how to plan from one payday to the next and work out what you can spend in between.",
    "date": "2026-09-15",
    "lang": "en",
    "tags": [
      "paycheck budget app",
      "paycheck budgeting",
      "budgeting apps",
      "envelope budgeting",
      "cash flow planning"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/paycheck-budget-app/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "Budget apps for couples and households: 10 compared",
    "slug": "budget-app-for-couples",
    "description": "Ten budget apps for couples and shared households, compared on sharing, bank links, privacy and price. Plus what works when one person keeps the books.",
    "date": "2026-09-11",
    "lang": "en",
    "tags": [
      "budget app for couples",
      "couples budgeting",
      "shared budget apps",
      "household finance",
      "budgeting apps"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/budget-app-for-couples/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "Best budget apps for iPhone in 2026: 10 compared",
    "slug": "budget-app-for-iphone",
    "description": "Ten budget apps for iPhone compared on privacy, bank sync, offline use, budgeting method and price, including apps that never ask for a bank login.",
    "date": "2026-09-10",
    "lang": "en",
    "tags": [
      "budget app for iphone",
      "iPhone budgeting apps",
      "budgeting apps",
      "expense tracker",
      "personal finance apps"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/budget-app-for-iphone/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "Cash flow tracker: see what comes in and what goes out",
    "slug": "cash-flow-tracker",
    "description": "What a cash flow tracker is, why it matters, and how to set one up by hand or in an app, with practical examples.",
    "date": "2026-09-09",
    "lang": "en",
    "tags": [
      "cash flow tracker",
      "budget tracking",
      "personal finance",
      "expense tracker",
      "money management"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/cash-flow-tracker/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "How to back up your financial data",
    "slug": "data-backup-best-practices",
    "description": "Where copies of your financial data should live, how often to make them, and how to check that a restore works before you need it.",
    "date": "2026-09-07",
    "lang": "en",
    "tags": [
      "data backup best practices",
      "personal finance",
      "encrypted backup",
      "restore testing",
      "data retention"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/data-backup-best-practices/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "What is budget planning? How to plan and forecast your money",
    "slug": "what-is-budget-planning",
    "description": "What budget planning is, the parts of a plan that matter, how to forecast the next few months, and how to adjust when things change.",
    "date": "2026-09-06",
    "lang": "en",
    "tags": [
      "budget planning",
      "personal budgeting",
      "expense tracking",
      "budget categories",
      "money management"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/what-is-budget-planning/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "How to track your net worth: formula, example and routine",
    "slug": "how-to-track-your-net-worth",
    "description": "What net worth is, how to calculate it with a worked example, and a monthly routine for tracking it without fooling yourself.",
    "date": "2026-08-31",
    "lang": "en",
    "tags": [
      "net worth",
      "track net worth",
      "personal finance",
      "budget app",
      "balance sheet"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/how-to-track-your-net-worth/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "Net worth spreadsheet templates: 10 options compared",
    "slug": "net-worth-tracking-spreadsheet",
    "description": "Ten net worth templates for Google Sheets and Excel compared, and how to keep one up to date with a CSV export from your budget app.",
    "date": "2026-08-30",
    "lang": "en",
    "tags": [
      "net worth tracking spreadsheet",
      "net worth tracker",
      "Google Sheets templates",
      "Excel spreadsheets",
      "personal finance"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/net-worth-tracking-spreadsheet/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "How to track credit card payments without double counting",
    "slug": "tracking-credit-card-payments",
    "description": "Record card purchases as spending and card payments as transfers, so nothing is counted twice. A method for any budget app or spreadsheet.",
    "date": "2026-08-28",
    "lang": "en",
    "tags": [
      "tracking credit card payments",
      "credit card tracking",
      "budget app tips",
      "manual expense tracking",
      "avoid double counting"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/tracking-credit-card-payments/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "How to budget with irregular income",
    "slug": "how-to-budget-with-irregular-income",
    "description": "Budget an irregular income with a conservative baseline, a fixed order for each payment, and pay-period plans that survive lean months.",
    "date": "2026-08-26",
    "lang": "en",
    "tags": [
      "irregular income budget",
      "variable income",
      "pay-period budget",
      "freelance budgeting",
      "income smoothing"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/how-to-budget-with-irregular-income/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "Are budgeting apps worth it? The honest pros and cons",
    "slug": "are-budgeting-apps-worth-it",
    "description": "What a budgeting app saves you, what a bank link costs in privacy, and when a manual app is the better fit.",
    "date": "2026-08-24",
    "lang": "en",
    "tags": [
      "budgeting apps",
      "are budgeting apps worth it",
      "manual budgeting",
      "privacy budget app",
      "expense tracker"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/are-budgeting-apps-worth-it/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "Ledgerly vs YNAB, an honest comparison",
    "slug": "ledgerly-vs-ynab",
    "description": "Two paid budget apps with opposite philosophies. Where each one wins, who should pick which, and the cases where YNAB is clearly the better choice.",
    "date": "2026-08-24",
    "lang": "en",
    "tags": [
      "budgeting",
      "comparisons",
      "ynab"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "locales": [
      "en"
    ]
  },
  {
    "title": "What happened to Mint users, and what it taught us",
    "slug": "what-happened-to-mint-users",
    "description": "Mint shut down in 2024 and moved millions of users to Credit Karma. Here is what that episode revealed about depending on a connected finance app.",
    "date": "2026-08-24",
    "lang": "en",
    "tags": [
      "budgeting",
      "mint",
      "privacy",
      "comparisons"
    ],
    "draft": false,
    "locales": [
      "en"
    ]
  },
  {
    "title": "Les alternatives à YNAB sans identifiants bancaires",
    "slug": "ynab-alternatives-without-bank-login",
    "description": "Vous quittez YNAB à cause de l'abonnement ? Les alternatives à saisie manuelle, ce que chacune fait de vos données, et à qui chacune convient vraiment.",
    "date": "2026-08-24",
    "lang": "fr",
    "tags": [
      "budget",
      "comparatifs",
      "ynab"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "locales": [
      "en",
      "fr"
    ]
  },
  {
    "title": "What does export to CSV mean? A plain guide",
    "slug": "what-does-export-to-csv-mean",
    "description": "Export to CSV saves your data as a plain text table any spreadsheet can open. What goes in the file, how to open it in Excel, and common fixes.",
    "date": "2026-08-23",
    "lang": "en",
    "tags": [
      "export to csv",
      "csv format",
      "csv export",
      "data export",
      "csv file structure"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/what-does-export-to-csv-mean/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "Day-to-day expenses app: track daily spending privately",
    "slug": "day-to-day-expenses-app",
    "description": "How manual entry, offline use and privacy change daily expense tracking, and which kind of app suits which habit.",
    "date": "2026-08-22",
    "lang": "en",
    "tags": [
      "day to day expenses app",
      "manual expense tracker",
      "privacy budget app",
      "offline budgeting",
      "daily spend tracker"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "image": "/assets/images/blog/day-to-day-expenses-app/cover.jpg",
    "locales": [
      "en"
    ]
  },
  {
    "title": "Best budget apps without bank linking (2026)",
    "slug": "best-budget-apps-without-bank-linking",
    "description": "Six ways to budget without giving any app your bank login, from a spreadsheet to local-only mobile apps. What each costs you in effort and in trust.",
    "date": "2026-08-17",
    "lang": "en",
    "tags": [
      "budgeting",
      "privacy",
      "comparisons"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "locales": [
      "en",
      "fr"
    ]
  },
  {
    "title": "Applis de budget sans connexion bancaire (2026)",
    "slug": "best-budget-apps-without-bank-linking",
    "description": "6 façons de tenir un budget sans donner vos identifiants bancaires, du tableur aux applis mobiles locales. Ce que chacune coûte en effort et en confiance.",
    "date": "2026-08-17",
    "lang": "fr",
    "tags": [
      "budget",
      "confidentialite",
      "comparatifs"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "locales": [
      "en",
      "fr"
    ]
  },
  {
    "title": "YNAB alternatives that don't need your bank login",
    "slug": "ynab-alternatives-without-bank-login",
    "description": "Leaving YNAB over the subscription? The alternatives that work on manual entry, what each does with your data, and who each one actually suits.",
    "date": "2026-08-17",
    "lang": "en",
    "tags": [
      "budgeting",
      "comparisons",
      "ynab"
    ],
    "draft": false,
    "updated": "2026-10-18",
    "locales": [
      "en",
      "fr"
    ]
  }
];
